export default __webpack_public_path__ + "static/media/points-redeemed.92c402c9.svg";